import { mutatorAction } from 'satcheljs';
import CLPViewState from '../../store/schema/clp/CLPViewState';
import CLPAuditAction from '../../store/schema/clp/CLPAuditAction';
import { isFeatureEnabled } from 'owa-feature-flags';

export default mutatorAction(
    'addAuditActionToViewState',
    (viewState: CLPViewState, auditAction: CLPAuditAction) => {
        if (isFeatureEnabled('cmp-clp-audit')) {
            viewState.auditActionStack.push(auditAction);
        }
    }
);
